import { Dialog } from '@datacamp/waffles/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: (...args: any[]) => any;
  successMessage: React.ReactNode;
};

const ReportModalSuccess: React.FC<Props> = ({ onClose, successMessage }) => {
  const { t } = useTranslation();
  return (
    <>
      <Dialog.Header>{t('ReportModalSuccess.header')}</Dialog.Header>
      <Dialog.Body>{successMessage}</Dialog.Body>
      <Dialog.Footer>
        <Dialog.Button
          data-cy="report-success-button"
          type="button"
          variant="primary"
          onClick={onClose}
        >
          {t('ReportModalSuccess.primaryButton')}
        </Dialog.Button>
      </Dialog.Footer>
    </>
  );
};

export default ReportModalSuccess;
